import InputLabel from '@mui/material/InputLabel';
import React from 'react';

interface Props {
  id?: string;
  className?: string;
  htmlFor?: string;
  error?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  isRequired?: boolean;
}

export default function Label(props: Props) {
  const children = props.isRequired ? <>{props.children} *</> : props.children;
  return <InputLabel {...props}>{children}</InputLabel>;
}
